import { ColumnDef } from "@tanstack/react-table";
import ActionButton from "../ActionButton";
import { FeaturedAdsStatusEnum } from "props/enum";
import { CircularProgress } from "@mui/material";
import { FeaturedAdsProps } from "modules/featured_ads/state/actionType";

export const TableColumns: ColumnDef<FeaturedAdsProps>[] = [
  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
    accessorFn: (row) => row?.name,
    id: "name",
    cell: (info) => info.getValue(),
    header: () => <span>Featured Ads Name</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.featured_order,
    id: "featured_order",
    cell: (info) => info.getValue(),
    header: () => <span>Featured Order</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.featured_type,
    id: "featured_type",
    cell: (info) => info.getValue(),
    header: () => <span>Featured Ads Type</span>,
    filterFn: "equalsString",
  },
  // {
  //   accessorFn: (row) => row?.upload_status,
  //   id: "upload_status",
  //   cell: (info) => {
  //     const upload_status = info.getValue();
  //     const playback_info = info.row.original.playback_info;
  //     const featured_type = info.row.original.featured_type;
  //     if (featured_type === "image") return null;

  //     const isUploading = !playback_info || playback_info === "";

  //     return (
  //       <span className="flex items-center gap-2">
  //         {isUploading ? (
  //          <> <CircularProgress size={20} thickness={5} className="text-white" /> Uploading...</>
  //         ) : (
  //           <>{String(upload_status)}</>
  //         )}
  //       </span>
  //     );
  //   },
  //   header: () => <span>Video Upload Status</span>,
  //   filterFn: "equalsString",
  // },

  {
    accessorFn: (row) => row?.status,
    id: "status",
    cell: (info) => {
      const status = info.getValue();
      return (
        <span
          className={
            status === FeaturedAdsStatusEnum.Published
              ? "text-primary-500"
              : "text-red-500"
          }
        >
          {String(status)}
        </span>
      );
    },
    header: () => <span>Status</span>,
    filterFn: "equalsString",
  },
  {
    id: "action",
    cell: ({ row }) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <ActionButton items={row.original} />
        </div>
      );
    },
    header: () => <span>Actions</span>,
    enableSorting: false,
  },
];
